<template>
	<div
		id="black-bar"
		:class="[mobileSearch ? barMobile : barWeb]"
		:style="{ width: algoliaObject.blackBarWidth }"
	>
		<div class="search-results">
			<h3 v-if="mobileSearch || algoliaObject.blackBarWidth === '100%'">Search Results:</h3>
			<br />
			<loading v-if="algoliaObject.showLoader"></loading>
			<ul v-if="!algoliaObject.noResults">
				<!-- <transition-group tag="li" name="slide-fade" class="transition-group"> -->
				<result-card
					v-for="item in algoliaObject.searchResults"
					:key="item.ObjectID"
					:result="item"
					:from="componentName"
				></result-card>
				<!-- </transition-group> -->
			</ul>
			<no-content v-else :header="noContentHeader" :paragraph="noContentParagraph"></no-content>
			<div v-if="!algoliaObject.noResults" class="algolia-search">
				<img src="../../static/search-by-algolia-light-background.png" alt="Algolia search logo" />
			</div>
		</div>
	</div>
</template>

<script>
import ResultCard from "./search/ResultCard.vue";
import NoContent from "./errors/NoContent.vue";
import Loading from "./errors/PageLoading.vue";

export default {
	data() {
		return {
			noContentHeader: "Sorry, there are no users matching that search.",
			noContentParagraph: "Try searching again",
			barMobile: "black-bar-mobile",
			barWeb: "black-bar-web",
			componentName: "blackBar"
		};
	},
	computed: {
		algoliaObject() {
			return this.$store.getters.getAlgoliaObject;
		},
		mobileSearch() {
			return this.$store.getters.mobileSearch;
		}
	},
	components: {
		ResultCard,
		NoContent,
		Loading
	}
};
</script>

<style scoped>
#black-bar {
	position: fixed;
	left: 0;
	background-color: #000;
	transition: all 0.5s ease-in-out;
	overflow-y: scroll;
}

.search-results {
	position: relative;
}

.black-bar-web {
	width: 410px;
	top: 0;
	z-index: 18;
	padding: 30px 20px 30px 400px;
	min-height: 100vh;
	height: 100vh;
}

h3 {
	color: #fff;
	font-weight: 500;
}

ul {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
	grid-gap: 20px;
}

.algolia-search {
	text-align: center;
	padding-top: 40px;
	width: 100%;
}

.algolia-search img {
	transform: scale(0.7);
}

.transition-group {
	display: grid;
	grid-gap: 20px;
	grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
}

@media only screen and (max-width: 768px) {
	#black-bar {
		/* transition: top 1s, min-height 1s, height 1s, z-index 0.5s ease-in; */
		transition: z-index 0.5s 0.1s, top 1s 0.5s, min-height 1s 0.5s,
			height 1s 0.5s ease-in;
	}

	.black-bar-web {
		width: 100%;
	}

	.black-bar-mobile {
		width: 100%;
		top: 150px;
		z-index: 40;
		padding: 20px;
		border-top: 2px solid #111;
		min-height: 86vh;
		height: 86vh;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/BlackBar.vue